/**
 * Schedule Status Icon Component
 *
 * Display-only indicator for scheduling status:
 * - Pin icon (📌) = Manually-scheduled (preserved when algorithm re-runs)
 * - Robot icon (🤖) = Algorithm-generated (cleared when algorithm re-runs)
 *
 * Status can be changed in the Edit Class dialog.
 */

import React from 'react';
import { Tooltip, Box } from '@mui/material';
import PushPinIcon from '@mui/icons-material/PushPin';
import SmartToyIcon from '@mui/icons-material/SmartToy';

interface ScheduleStatusIconProps {
  isManuallyScheduled: boolean;
}

const ScheduleStatusIcon: React.FC<ScheduleStatusIconProps> = ({
  isManuallyScheduled,
}) => (
  <Tooltip
    title={
      isManuallyScheduled
        ? 'Manually scheduled - will be preserved when algorithm re-runs'
        : 'Algorithm-generated - will be cleared when algorithm re-runs'
    }
    arrow
    placement="top"
  >
    <Box
      sx={{
        position: 'absolute',
        top: 2,
        right: 2,
        zIndex: 10,
        pointerEvents: 'none', // Don't interfere with clicks
      }}
    >
      {isManuallyScheduled ? (
        <PushPinIcon
          sx={{
            fontSize: 16,
            color: '#ffffff', // White
            filter: 'drop-shadow(0 1px 2px rgba(0,0,0,0.5))',
          }}
        />
      ) : (
        <SmartToyIcon
          sx={{
            fontSize: 16,
            color: '#ffffff', // White
            filter: 'drop-shadow(0 1px 2px rgba(0,0,0,0.5))',
          }}
        />
      )}
    </Box>
  </Tooltip>
);

export default ScheduleStatusIcon;
